import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initBenefitCards() {
  Alpine.data(
    'benefitCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.swiper-benefits');
        if (swiperEl) {
          this.initSwiper(swiperEl);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 20,
          slidesPerView: 3,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-benefits__buttons .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-benefits__buttons .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            992: {
              slidesPerView: 3,
            },
          },
        });
      },
    }),
  );
}
